export const convertDisplayToOptions = (
  displayObject: Record<string, string>
) => {
  return Object.entries(displayObject).map(([value, label]) => ({
    value,
    label,
  }));
};
